export default __webpack_public_path__ + "static/media/schneider-logo.0ea1cd14.webp";